import { render } from "./admin-view-log-company.vue?vue&type=template&id=536affd6"
import script from "./admin-view-log-company.vue?vue&type=script&lang=js"
export * from "./admin-view-log-company.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/admin/admin-view-log-company.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "536affd6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('536affd6', __exports__)) {
    api.reload('536affd6', __exports__)
  }
  
  module.hot.accept("./admin-view-log-company.vue?vue&type=template&id=536affd6", () => {
    api.rerender('536affd6', render)
  })

}


export default __exports__